if (!customElements.get('vt-rail')) {
  customElements.define('vt-rail', class extends HTMLElement {
    connectedCallback() {
      const io = new IntersectionObserver((items) => {
        if (!items.some((i) => i.isIntersecting)) return;
        io.disconnect();
        this.start();
      }, { rootMargin: '200px' });
      io.observe(this);
    }

    start() {
      const spoor = this.querySelector('[data-rail-spoor]');
      const bedien = this.querySelector('[data-rail-bedien]');
      if (!spoor || !bedien) return;
      const kaarten = [...spoor.children];
      if (kaarten.length < 2) return;
      const punten = [...this.querySelectorAll('[data-rail-punt]')];
      const teller = this.querySelector('[data-rail-teller]');
      const voortgang = this.querySelector('[data-rail-voortgang]');
      const vorige = this.querySelector('[data-rail-vorige]');
      const volgende = this.querySelector('[data-rail-volgende]');
      const twee = (n) => String(n).padStart(2, '0');
      let nu = -1;

      const naar = (i) => {
        const k = kaarten[Math.max(0, Math.min(kaarten.length - 1, i))];
        spoor.scrollTo({ left: k.offsetLeft - kaarten[0].offsetLeft });
      };

      const bij = () => {
        const eind = spoor.scrollLeft + spoor.clientWidth >= spoor.scrollWidth - 2;
        const stap = kaarten[1].offsetLeft - kaarten[0].offsetLeft || 1;
        const i = eind ? kaarten.length - 1 : Math.round(spoor.scrollLeft / stap);
        if (i === nu) return;
        nu = i;
        punten.forEach((p, j) => p.setAttribute('aria-current', j === i ? 'true' : 'false'));
        if (teller) teller.textContent = twee(i + 1) + ' / ' + twee(kaarten.length);
        if (voortgang) voortgang.style.setProperty('--vt-rail-deel', (i + 1) / kaarten.length);
        if (vorige) vorige.disabled = i === 0;
        if (volgende) volgende.disabled = i === kaarten.length - 1;
      };

      const scrollt = () => { bedien.hidden = spoor.scrollWidth <= spoor.clientWidth + 2; };

      let wacht = false;
      spoor.addEventListener('scroll', () => {
        if (wacht) return;
        wacht = true;
        requestAnimationFrame(() => { wacht = false; bij(); });
      }, { passive: true });
      let doel = null;
      let klok;
      const stap = (r) => {
        doel = Math.max(0, Math.min(kaarten.length - 1, (doel ?? nu) + r));
        naar(doel);
        clearTimeout(klok);
        klok = setTimeout(() => { doel = null; }, 600);
      };
      if (vorige) vorige.addEventListener('click', () => stap(-1));
      if (volgende) volgende.addEventListener('click', () => stap(1));
      punten.forEach((p, j) => p.addEventListener('click', () => naar(j)));
      new ResizeObserver(() => { scrollt(); nu = -1; bij(); }).observe(spoor);
    }
  });
}
